import { createStore } from '@/common/pinia';
import type { ApiResponse } from '@/common/services/api.service-new';
import type { SoilLayerResponse, SoilSocStatsResponse } from './soil.types';

/**
 * Cache for the SOC Stock product served via the analytics infrastructure
 * (`<SoilTool>`). SOC is a single fixed epoch (no year), so the tile-URL response is a
 * single slot, not a per-year Map. Stats are cached per polygon fingerprint. Sibling
 * of `EsaWorldcoverStore`.
 */
class SoilStore {
  private socLayer: ApiResponse<SoilLayerResponse> | null = null;

  /** Per-polygon stats keyed by `JSON.stringify(coords)`. */
  private socStatsCache: Map<string, SoilSocStatsResponse> = new Map();

  public getSocLayer(): ApiResponse<SoilLayerResponse> | null {
    return this.socLayer;
  }

  public setSocLayer(layer: ApiResponse<SoilLayerResponse>): void {
    this.socLayer = layer;
  }

  public getSocStatsCache(fingerprint: string): SoilSocStatsResponse | undefined {
    return this.socStatsCache.get(fingerprint);
  }

  public setSocStatsCache(fingerprint: string, stats: SoilSocStatsResponse): void {
    this.socStatsCache.set(fingerprint, stats);
  }
}

const useSoilStore = createStore(SoilStore);

export { useSoilStore, type SoilStore };
